/**
 * Calculates the ordinal suffix for a number.
 *
 * @param rank - The number to return the ordinal suffix for.
 */
export function getOrdinalSuffix(rank: number) {
  // Calculate rank modulo 10 and 100
  const modTen = rank % 10;
  const modHundred = rank % 100;

  if (modTen === 1 && modHundred !== 11) {
    return 'st';
  } else if (modTen === 2 && modHundred !== 12) {
    return 'nd';
  } else if (modTen === 3 && modHundred !== 13) {
    return 'rd';
  }

  return 'th';
}

/**
 * Rounds off a number. This ensures that decimals only appear if any.
 *
 * @param num - The number to be rounded off.
 * @param significantFigures - The number of significantFigures to be rounded into.
 */
export function roundOffNumber(num: number, significantFigures = 2) {
  const roundOffHelperNumber = 10 ** significantFigures;
  // The Number.EPSILON property represents the difference between 1
  // and the smallest floating point number greater than 1.
  return Math.round((num + Number.EPSILON) * roundOffHelperNumber) / roundOffHelperNumber;
}
